<template>
  <div>
    <MqResponsive target="xs-md">
      <!-- <MobileHome /> -->
      <el-container>
        <el-header
          style="position: fixed; z-index: 100; width: 100%; background: #fff"
        >
          <div
            style="
              display: flex;
              width: 95%;
              justify-content: space-between;
              padding: 10px 20px 0 10px;
            "
          >
            <img
              style="height: 50px"
              src="@/assets/logo/logo.png"
              alt="Element logo"
            />
            <el-menu
              default-active="1"
              class="el-menu-vertical-demo"
              :collapse="true"
              @open="handleOpen"
              @close="handleClose"
              router="true"
            >
              <el-sub-menu index="1">
                <template #title>
                  <!-- <el-icon><icon-menu /></el-icon> -->
                  <img
                    style="height: 45px"
                    src="@/assets/Icon - 直播中.png"
                    alt="Element logo"
                  />
                </template>
                <el-menu-item-group>
                  <el-menu-item index="Home">首页</el-menu-item>
                  <el-menu-item index="1-2">item two</el-menu-item>
                  <el-menu-item index="1-3">item two</el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>
            </el-menu>
          </div>
        </el-header>
        <el-main><router-view></router-view></el-main>
      </el-container>
    </MqResponsive>
    <!--  -->
    <MqResponsive target="md+">
      <!-- <MobileHome /> -->
      <el-container>
        <el-header
          style="
            position: fixed;
            z-index: 100;
            background: #fff;
            width: 100%;
            height: 95px;
            padding: 0;
          "
        >
          <div
            style="
              background: #333333;
              width: 100%;
              color: #fff;
              display: flex;
              justify-content: end;
            "
          >
            <div
              style="
                width: 60%;
                font-size: 12px;
                text-align: end;
                display: flex;
                justify-content: space-between;
                padding: 10px 250px 10px 0;
              "
            >
              <span>欢迎您访问广州超交市场咨询服务有限公司官方网站！</span>
              <span>服务电话：18310090624</span>
            </div>
          </div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            :ellipsis="false"
            @select="menuSelect"
            @open="handleOpen"
            @close="handleClose"
            text-color="#333333"
            active-text-color="#333333"
            router="true"
            style="padding: 0px 200px"
          >
            <div style="height: 50%; position: relative; z-index: 999">
              <img
                style="width: 200px; margin-bottom: 10px"
                src="@/assets/logo/1.png"
                alt="Element logo"
              />
              <img
                style="
                  width: 100px;
                  margin-bottom: 10px;
                  position: absolute;
                  left: 25%;
                "
                src="@/assets/logo/logo.png"
                alt="Element logo"
              />
            </div>
            <!-- <div style="width: 160px; margin-right: 20px"></div> -->
            <el-menu-item index="Home">{{ $t("首页") }}</el-menu-item>
            <el-menu-item index="AboutUs">{{ $t("关于我们") }}</el-menu-item>

            <el-menu-item index="MainBusiness">{{
              $t("主营业务")
            }}</el-menu-item>
            <el-menu-item index="OfflineForum">{{
              $t("线下论坛")
            }}</el-menu-item>

            <el-menu-item index="AppointmentRegistration">{{
              $t("预约报名")
            }}</el-menu-item>

            <el-menu-item index="EmpoweringCollaboration">{{
              $t("合作赋能")
            }}</el-menu-item>

            <el-menu-item index="FinancialForum">{{
              $t("金融论坛")
            }}</el-menu-item>
            <el-menu-item index="ContactUs">{{ $t("联系我们") }}</el-menu-item>
            <div class="flex-grow" />

            <!-- <el-menu-item index="PersonalCenter">个人中心</el-menu-item> -->
            <!-- <el-menu-item
              ><el-button
                type="danger"
                style="background: #cd0104; border-color: #cd0104"
                >登录/注册</el-button
              ></el-menu-item
            > -->
            <!-- <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                Dropdown List<el-icon class="el-icon--right"
                  ><arrow-down
                /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="a">Action 1</el-dropdown-item>
                  <el-dropdown-item command="b">Action 2</el-dropdown-item>
                  <el-dropdown-item command="c">Action 3</el-dropdown-item>
                  <el-dropdown-item command="d" disabled
                    >Action 4</el-dropdown-item
                  >
                  <el-dropdown-item command="e" divided
                    >Action 5</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown> -->
            <el-menu-item>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link" style="color: #333333">
                  {{ language }}：{{ lang
                  }}<el-icon class="ArrowDownBold"><arrow-down /></el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="中文" :icon="CirclePlusFilled">
                      中文
                    </el-dropdown-item>
                    <el-dropdown-item command="EN" :icon="CirclePlus"
                      >EN</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </template>
                <!-- <template></template>
                <el-select
                  v-model="lang"
                  placeholder="Please select a zone"
                  @change="changeLang"
                >
                  <el-option label="中文" value="cn" />
                  <el-option label="EN" value="en" />
                </el-select> -->
              </el-dropdown>
            </el-menu-item>
            <!-- <el-menu-item>
              <el-input
                v-model="input3"
                class="w-50 m-2"
                size="small"
                placeholder="Please Input"
                :suffix-icon="Search"
              />
            </el-menu-item> -->
          </el-menu></el-header
        >
        <div style="height: 95px; background: #fff"></div>
        <el-main><router-view></router-view></el-main>
      </el-container>
    </MqResponsive>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
} from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { ArrowDown } from "@element-plus/icons-vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();

const language = ref();
const lang = ref("");
if (localStorage.getItem("lang") == "中文") {
  lang.value = "中文";
  language.value = "语言";
  locale.value = "zh";
} else {
  lang.value = "EN";
  language.value = "language";
  locale.value = "en";
}
const handleCommand = (command) => {
  // ElMessage(`click on item ${command}`);
  localStorage.setItem("lang", command);
  if (command == "中文") {
    localStorage.setItem("locale", "zh");
  } else {
    localStorage.setItem("locale", "en");
  }
  window.location.reload();
  lang.value = command;
};

const isCollapse = ref(true);
const activeIndex = ref("Home");

activeIndex.value = localStorage.getItem("menu");

const handleOpen = (key, keyPath) => {
  console.log(key, keyPath);
};
const handleClose = (key, keyPath) => {
  console.log(key, keyPath);
};
const menuSelect = (index) => {
  localStorage.setItem("menu", index);
};
</script>

<style scoped>
.flex-grow {
  flex-grow: 1;
}
.el-menu {
  /* background: black; */
  height: 80px;
  /* padding: 0 20px; */
  border: none;
  background: rgba(0, 0, 0, 0);
}
/deep/.el-main {
  --el-main-padding: 0;
  box-sizing: border-box;
  display: block;
  flex: 1;
  flex-basis: auto;
  overflow: hidden;
}
.el-menu--horizontal.el-menu {
  border: none;
}
.el-menu--collapse {
  width: 60px;
}

.el-menu--horizontal > .el-menu-item {
  align-items: center;
  border-bottom: 2px solid transparent;
  color: var(--el-menu-text-color);
  display: inline-flex;
  height: 70%;
  justify-content: center;
  margin: 0;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid var(--el-menu-active-color);
  color: var(--el-menu-active-color) !important;
  height: 70%;
}
.el-sub-menu.is-active .el-sub-menu__title {
  border-bottom-color: var(--el-menu-active-color);
  height: 86%;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgba(0, 0, 0, 0);
}
/deep/.el-menu--horizontal > .el-sub-menu .el-sub-menu__title {
  border-bottom: 2px solid transparent;
  color: var(--el-menu-text-color);
  height: 75%;
}
.el-menu--horizontal > .el-menu-item.is-active[data-v-02ff0d5c] {
  border-bottom: 2px solid var(--el-menu-active-color);
  color: var(--el-menu-active-color) !important;
  height: 75%;
  border-bottom: 4px solid;
}

.el-menu--horizontal > .el-menu-item[data-v-02ff0d5c] {
  height: 75%;
}

/deep/.el-menu-item:hover {
  /* background-color: var(--el-menu-hover-bg-color); */
  background-color: #fff;
}
/deep/.el-menu--horizontal
  > .el-menu-item.is-active[data-v-02ff0d5c][data-v-02ff0d5c] {
  background-color: #fff;
}
</style>
